import styled from 'styled-components';
import Select from '@mui/material/Select';
import AppCSS from '../../../utils/styled';
import { MAX_SELECT_HEIGHT } from '../ProjectSelect/constants';
import MenuItem from '@mui/material/MenuItem';

export const Components = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    width: 100%;
    min-width: max-content;
  `,
  Select: styled(Select)`
    width: 100%;
    color: ${AppCSS.colors.black};
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    & .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    & .MuiOutlinedInput-input {
      ${AppCSS.fonts.label12Medium};
      padding-left: 12px;
      padding-right: 40px !important;
      padding-top: 0;
      padding-bottom: 0;
      min-height: auto;
      white-space: break-spaces;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    & .MuiSelect-icon {
      right: 12px;
    }
    ${AppCSS.fonts.label12Medium};
    background-color: ${AppCSS.colors.white};
    height: 40px;
  `,
  ItemsWrapper: styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  `,
  Item: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.greys.light};
    padding: 4px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
  `,
  ClearButton: styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 32px;
  `,
};

export const styles = {
  SelectMenu: `
    & .MuiPaper-root {
      overflow-x: hidden;
      overflow-y: auto;
      max-height: ${MAX_SELECT_HEIGHT}px !important;
      ${AppCSS.boxShadows.menu};
      & .MuiList-root {
        padding: 0;
      }
      & .MuiMenuItem-root {
        ${AppCSS.fonts.label12Regular};
        color: ${AppCSS.colors.black};
        padding: 12px;
        min-width: 200px;
        border-bottom: 1px solid ${AppCSS.colors.greys.light};
        &:hover {
          background-color: ${AppCSS.colors.utility.screenBackground};
        }
      }
      & .MuiMenuItem-root:last-child {
        border-bottom: 0;
      }
    }
  `,
};
